module.exports = __webpack_public_path__ + "09_mole.94de6b5a.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/daughter/layer2/09_mole.png
// module id = g5ZX
// module chunks = 0